var React = require('react');

function Ds (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m82.334 777.976-.397-649.931s281.218 202.968 380.734 274.174L132.728 643.044l-2.261 105.982L575.445 430.64v-62.16L60.453.001-.001 31.08v810.77l82.335-63.875Z"}));
}

Ds.defaultProps = {"viewBox":"0 0 576 842","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Ds;

Ds.default = Ds;
